import { render, staticRenderFns } from "./ExtraMenu.vue?vue&type=template&id=85e286ea&"
import script from "./ExtraMenu.vue?vue&type=script&lang=js&"
export * from "./ExtraMenu.vue?vue&type=script&lang=js&"
import style0 from "./ExtraMenu.vue?vue&type=style&index=0&id=85e286ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports